import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Wistle = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="whistle"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 53 41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M50.3009 11.6898H22.4083C15.599 11.6898 9.88666 16.42 8.34857 22.7621C7.46368 21.8612 6.23493 21.298 4.87431 21.298C2.18635 21.298 0 23.4819 0 26.1723C0 28.8603 2.18635 31.0429 4.87431 31.0429C6.23493 31.0429 7.46491 30.4834 8.34857 29.5788C9.88666 35.9209 15.5978 40.6523 22.4083 40.6523C29.57 40.6523 35.5313 35.4267 36.6861 28.5891H50.3009C51.791 28.5891 52.9988 27.3813 52.9988 25.8888V14.3901C53 12.9001 51.791 11.6898 50.3009 11.6898ZM4.87431 28.0752C3.82427 28.0752 2.97142 27.2211 2.97142 26.1723C2.97142 25.121 3.8255 24.2694 4.87431 24.2694C5.92312 24.2694 6.77597 25.121 6.77597 26.1723C6.77721 27.2199 5.92312 28.0752 4.87431 28.0752Z" />
      <path d="M11.9313 10.344C12.3195 11.0662 13.2192 11.3386 13.9426 10.9504C14.6649 10.5634 14.9372 9.66248 14.549 8.9378L10.6989 1.76252C10.3106 1.04154 9.40972 0.767935 8.68751 1.15616C7.96407 1.54437 7.6917 2.44652 8.07992 3.1712L11.9313 10.344Z" />
      <path d="M2.37251 12.0411L10.1689 14.3926C10.5621 14.5121 10.9651 14.4604 11.3003 14.2792C11.6343 14.1005 11.9018 13.7924 12.0201 13.3992C12.2567 12.6129 11.813 11.7847 11.0267 11.5481L3.23153 9.19907C2.44523 8.96121 1.61702 9.40612 1.3804 10.1912C1.14253 10.9787 1.58868 11.8069 2.37251 12.0411Z" />
      <path d="M17.0447 10.7051C17.4379 10.8247 17.8409 10.7717 18.1761 10.5917C18.5101 10.4118 18.7775 10.1037 18.8946 9.70931L21.2449 1.9141C21.4815 1.12781 21.0378 0.299604 20.2515 0.0629747C19.4665 -0.172422 18.6383 0.27249 18.4004 1.05756L16.0501 8.85399C15.8147 9.64153 16.2584 10.4685 17.0447 10.7051Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Wistle.defaultProps = {
  className: null,
};

Wistle.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Wistle;
